var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.modelValue, function(item, index) {
          return _c("item-proforma", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.similiarToSearch(
                    _vm.modelValue[index].selectedItem
                      ? _vm.modelValue[index].selectedItem.nombre
                      : ""
                  ) || _vm.similiarToSearch(_vm.modelValue[index].descripcion),
                expression:
                  "similiarToSearch(modelValue[index].selectedItem?modelValue[index].selectedItem.nombre:'') || similiarToSearch(modelValue[index].descripcion)"
              }
            ],
            key: _vm.moment(new Date()).format("YYYYMMDDHH:mm:ss") + index,
            tag: "tr",
            attrs: {
              totalItems: _vm.modelValue.length,
              retencionServicios: _vm.retencionServicios,
              retencionProductos: _vm.retencionProductos,
              errores: _vm.errores,
              valorIrbpnr: _vm.irbpnr,
              tarifas: _vm.tarifas,
              index: index
            },
            on: {
              cambiarIndice: _vm.cambiarIndice,
              changed: _vm.changedItem,
              eliminar: _vm.eliminarItem,
              updated: _vm.updatedTr
            },
            model: {
              value: _vm.modelValue[index],
              callback: function($$v) {
                _vm.$set(_vm.modelValue, index, $$v)
              },
              expression: "modelValue[index]"
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("tfoot", [
        _c("tr", [
          _c("td", { attrs: { colspan: "2" } }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.addRow }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            )
          ]),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "2" } }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      placeholder: "###.## %",
                      vMoney: "",
                      format: _vm.porcentaje,
                      id: "margenTotal"
                    },
                    model: {
                      value: _vm.margenTotal,
                      callback: function($$v) {
                        _vm.margenTotal = $$v
                      },
                      expression: "margenTotal"
                    }
                  },
                  [_c("span", [_vm._v("Marg. Total %")])]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-secondary",
                    on: { click: _vm.calcularMarginacionPorItem }
                  },
                  [_c("i", { staticClass: "fa fa-check" })]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "2" } }, [
            _c(
              "button",
              {
                staticClass: "btn-info btn--text",
                attrs: { type: "button" },
                on: { click: _vm.verTotales }
              },
              [
                _c("i", { staticClass: "fa fa-eye" }),
                _c("span", [_vm._v("Ver totales")])
              ]
            )
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "strong",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ]
              },
              [_vm._v("Cant. totales")]
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("input-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ],
                attrs: {
                  id: "cantidadesTotales",
                  vMoney: "",
                  format: _vm.decimal,
                  value: _vm.cantidades_totales
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "2" } }, [
            _c(
              "strong",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ]
              },
              [_vm._v("Costos totales")]
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("input-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ],
                attrs: {
                  id: "costosTotales",
                  vMoney: "",
                  format: _vm.money,
                  value: _vm.costes_totales
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _c(
              "strong",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ]
              },
              [_vm._v("Total")]
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("input-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ],
                attrs: {
                  id: "totales",
                  vMoney: "",
                  format: _vm.money,
                  value: _vm.totales
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _c(
              "strong",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ]
              },
              [_vm._v("Util.")]
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("input-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ],
                attrs: {
                  id: "utilidadTotal",
                  vMoney: "",
                  format: _vm.money,
                  value: _vm.margen_utilidad
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _c(
              "strong",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ]
              },
              [_vm._v("%Util.")]
            )
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("input-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.totalesOcultos,
                    expression: "!totalesOcultos"
                  }
                ],
                attrs: {
                  id: "porcentajeUtilidad",
                  vMoney: "",
                  format: _vm.decimal,
                  value: _vm.porcentaje_utilidad
                }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Posición")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripción")]),
        _vm._v(" "),
        _c("th", [_vm._v("Categoría")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo de item")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Precio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Coste")]),
        _vm._v(" "),
        _c("th", [_vm._v("% Descuento")]),
        _vm._v(" "),
        _c("th", [_vm._v("IVA")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Imp.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Retención")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("% Utilidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Mostrar Obs.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Observación")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c63474f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c63474f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaItemsProforma.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7c63474f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaItemsProforma.vue
// module chunks = 0